<template>
    <div>
        <v-row>
            <ActionDropdown 
                :items="actions"
                context="AzPersons"
                :alvqa="alvqa"
                cols="2"
            />
            <!-- <HelpIcon
                :urls="{
                    de: '196411417',
                    en: '199262212',
                    ko: '201097220',
                }"
                :tooltipText="$t('lang_GENERIC_CLICK_TO_HELP_CENTER')"
            /> -->
            <ImportButton
                :items="importOptions"
                context="FileImport"
                cols="2"
                :alvqa="alvqa"
            />
            <v-col 
                align-self="center"
                class="v-label theme--light mt-3"
            >
                <BaseHeaderStats 
                    context="AzPersons" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'"
                />
            </v-col>
                <v-spacer />
            <v-col 
                    cols="2"
                    align-self="center"
                >
                <BaseButton 
                    label="lang_GENERIC_CAPTION_EXPORT"
                    @click="exportAzPersons"
                    block
                    icon="library_books"
                    :alvqa="alvqa + '-list-button-export-all'"
                />
            </v-col>               
            <v-col 
                cols="2" 
                align-self="center"
            >
                <BaseButton
                    label="lang_AZ_PERSONS_BUTTON_CAPTION_NEW_PERSON"
                    :to="{name: editForm, params: { alvId: 'new'}}"
                    block
                    color="buttonNewEntity"
                    :alvqa="alvqa + '-list-button-new'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import ActionDropdown from '@/components/_actions/ActionDropdown'
import ImportButton from '@/components/_buttons/ImportButton'
import HelpIcon from '@/components/_buttons/HelpIcon'

export default {
    name: "AzPersonsTopSlot",
    components: {
        BaseButton,
        BaseHeaderStats,
        ActionDropdown,
        ImportButton,
        HelpIcon,
    },
    data() {
        return {
            editForm: "AzPersonsEdit",
            alvqa: "az-persons"
        }
    },
    computed: {
        importOptions(){
            return [ 
                {
                    text:this.$t('lang_GENERAL_CAPTION_EXCEL_TEMPLATE'),
                    value: "alvExcelTemplateAzPersons",
                    alvqa: this.alvqa + '-list-import-dropdown-alv-template'             
                },
                {
                    text: this.$t('lang_ACCOUNT_MAPPINGS'),
                    value: 'mappingImport',
                    alvqa: this.alvqa + '-list-import-dropdown-mapping-import'
                }
            ]
        },
        actions() {
            return [
                {
                    text: this.$t("lang_AZ_PERSONS_ACTION_OPTION_PRINT_A4_LABELS"),
                    value: "printAzPersonsA4Labels",
                    alvqa: this.alvqa + '-list-action-dropdown-print-a4-labels'
                },
                // A6 printing has *Firma selector, currently only for selected Labelfirma in ALV3
                {
                    text: this.$t("lang_AZ_PERSONS_ACTION_OPTION_PRINT_A6_LABELS"),
                    value: "printAzPersonsA6Labels",
                    alvqa: this.alvqa + '-list-action-dropdown-print-a6-labels'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_MANAGE_TAGS'),
                    value: 'replaceTags',
                    alvqa: this.alvqa + '-list-action-dropdown-manage-tags'
                },
                {
                    text: this.$t('lang_AZ_PERSONS_ACTION_SYNC_CONTACTS'),
                    value: 'syncData',
                    alvqa: this.alvqa + '-list-action-dropdown-sync-data'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ACTION_SHOW_CONNECTIONS'),
                    value: 'showConnections',
                    alvqa: this.alvqa + '-list-action-dropdown-show-connections'
                },
                {
                    text: this.$t('lang_AZ_CAPTION_REASSIGN_CONNECTIONS'),
                    value: 'reassignConnections',
                    alvqa: this.alvqa + '-list-action-dropdown-reassign-connections'
                },
                {
                    text: this.$t('lang_AZ_PERSONS_ACTION_CONVERT_TO_GROUP'),
                    value: 'convertToGroup',
                    alvqa: this.alvqa + '-list-action-dropdown-convert-to-group'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ASSIGN_MAPPINGS'),
                    value: 'assignTemplates',
                    alvqa: this.alvqa + '-list-action-dropdown-assign-templates'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete',
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                }
            ]
        },
    },
    methods:{
            exportAzPersons(){
                this.$store.dispatch('exportAzPersons')
            }
        }
}
</script>
